module.exports = __webpack_public_path__ + "assets/shinyInvert2-bg-9056e44ac15764e9f6fe2a3d22a70cb0.png";


//////////////////
// WEBPACK FOOTER
// ./button/libs/mfButtons/images/shinyInvert2-bg.png
// module id = 62
// module chunks = 4